// extracted by mini-css-extract-plugin
export default {"color":"AdditionalFilters_color__rt8T4","label":"AdditionalFilters_label__ZyBhW","mana":"AdditionalFilters_mana__x-IMD","number":"AdditionalFilters_number__HT0NT"};